module.exports = __webpack_public_path__ + "static/media/lantinx-protest.db54cacc.mov";